export type FactureDocumentPresentationInput = {
  numero?: string | null;
  document?: {
    status?: "READY" | "GENERATING" | "FAILED" | "MISSING" | null;
    available?: boolean | null;
    url?: string | null;
  } | null;
};

export function isCommercialFactureNumero(numero?: string | null): boolean {
  return String(numero ?? "").toUpperCase().startsWith("FAC-");
}

export function factureDocumentState(input: FactureDocumentPresentationInput): {
  status: "READY" | "GENERATING" | "FAILED" | "MISSING";
  available: boolean;
  canDownload: boolean;
  label: string;
  message: string;
} {
  const status =
    input.document?.status ??
    (input.document?.url || input.document?.available || isCommercialFactureNumero(input.numero)
      ? "READY"
      : "MISSING");
  const available = status === "READY";
  const labels: Record<typeof status, { label: string; message: string }> = {
    READY: { label: "Document disponible", message: "Document prêt pour consultation, téléchargement ou impression." },
    GENERATING: { label: "Préparation du document", message: "Document en préparation." },
    FAILED: { label: "Document à régénérer", message: "Le document doit être régénéré." },
    MISSING: { label: "Document absent", message: "Préparer le document commercial." },
  };
  return {
    status,
    available,
    canDownload: Boolean(input.document?.url),
    label: labels[status].label,
    message: labels[status].message,
  };
}
